import React, {Component} from 'react'

class ReportCustomerScreen extends Component {

    constructor(props) {
        super(props);
        this.state = {
            servidor: props.servidor,
        }
    }

    render() {
        //let empresa = this.state.servidor
        //let empresa_upper = empresa.charAt(0).toUpperCase() + empresa.slice(1)

        return(
            <div>
                <p className="negrito">Prezado Cliente,</p>
                <p>Este <span className="negrito">Canal de Denúncias</span> é destinado aos seus funcionários, colaboradores, clientes, usuários, parceiros ou fornecedores para que comuniquem situações de descumprimento de políticas internas ou que afetem o Código de Ética, bem como situações com indícios de ilicitude de qualquer natureza, relacionadas às atividades da Instituição.</p>
                
                <p><a href="/RegulamentoDoCanalDeDenuncias.pdf" target="_blank">Clique aqui e confira o regulamento</a></p>

                <p>Para dúvidas e reclamações sobre contratos em andamento e outras questões nao diretamente relacionadas a uma denúncia, por favor, entre em contato com os canais de atendimento informados em nossa página na internet:</p>
                <p><a href="http://www.crefisa.com.br" target="_blank" rel="noopener noreferrer">http://www.crefisa.com.br</a></p>

                <br /><br />
                <p align="center">
                    <a href="/bemvindo" title="Realizar denúncia" shape="rect" className="bt_realizar_denuncia"></a>
                </p>
            </div>
        )
    }
}
export default ReportCustomerScreen